module.exports = "/_next/static/images/delivery-man 1-a8f2e52c64380ffa13b3bfd873e0d3d4.svg";